"use client";

import { useEffect, useState } from "react";
import { useSearchParams } from "next/navigation";
import {
  getBannerState,
  shouldShowBanner,
  markBannerDismissed,
} from "@/lib/shareBannerHelpers";

export default function ShareWelcomeBanner({ kind, status }) {
  const searchParams = useSearchParams();
  const [visible, setVisible] = useState(false);

   
  useEffect(() => {
    const refParam = searchParams.get("ref");
    const storage =
      typeof window !== "undefined" ? window.sessionStorage : null;
    setVisible(shouldShowBanner({ refParam, storage }));
  }, [searchParams]);

  if (!visible) return null;

  const state = getBannerState({ kind, status });
  if (!state) return null;

  const handleDismiss = () => {
    const storage =
      typeof window !== "undefined" ? window.sessionStorage : null;
    markBannerDismissed(storage);
    setVisible(false);
  };

  return (
    <div
      role="region"
      aria-label="分享歡迎"
      className="w-full"
      style={{
        backgroundColor: "var(--color-bgSecondary, #fdf2f8)",
        borderBottom: "1px solid var(--color-cardBorder)",
      }}
    >
      <div className="max-w-5xl mx-auto flex items-start gap-3 px-4 py-3 md:px-6 md:py-3">
        <span aria-hidden="true" style={{ fontSize: "20px", lineHeight: 1 }}>
          {state.icon}
        </span>
        <div className="flex-1 min-w-0">
          <p
            className="text-[13px] md:text-sm font-medium"
            style={{ color: "var(--color-text)" }}
          >
            {state.title}
          </p>
          <p
            className="text-xs md:text-xs mt-0.5"
            style={{ color: "var(--color-textMuted)" }}
          >
            {state.subtitle}
          </p>
        </div>
        <a
          href={state.ctaHref}
          className="shrink-0 text-xs md:text-sm font-medium whitespace-nowrap self-center"
          style={{ color: "var(--color-accent)" }}
        >
          {state.ctaText}
        </a>
        <button
          type="button"
          onClick={handleDismiss}
          aria-label="關閉歡迎橫幅"
          className="shrink-0 w-8 h-8 flex items-center justify-center -mr-2"
          style={{
            color: "var(--color-textMuted)",
            cursor: "pointer",
            background: "none",
            border: "none",
          }}
        >
          <svg
            width="16"
            height="16"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            aria-hidden="true"
          >
            <line x1="18" y1="6" x2="6" y2="18" />
            <line x1="6" y1="6" x2="18" y2="18" />
          </svg>
        </button>
      </div>
    </div>
  );
}
